<script setup>
import Layout from "../../../layouts/main.vue";
import mushroom from "cem-primary-api";
import { useRoute, useRouter } from "vue-router";
import { onMounted, reactive, ref, watch } from "vue";
import { FormInstance } from "element-plus";
import toastr from "toastr";
import { useI18n } from "vue-i18n";

import { langWeb } from "../../../stores/lang";
const lang_web = langWeb();
const lang = ref(lang_web.showLang.toLocaleUpperCase());

// data khai báo
import MethodService from "../../../service/MethodService";
import Data from "./dataFormSearchStrategy";
import IconPicker from "../../../components/IconPicker.vue";
const { t } = useI18n();
const ruleFormRef = ref(FormInstance);
const dataForm = reactive({
  value: MethodService.copyObject(Data.dataForm),
});
const loadingBtn = ref(false);
const validateFlag = ref(false);

const router = useRoute();
const routerPush = useRouter();

// validate form
import Validate from "../../../service/ValidService";
import LanguageService from "../../../service/LanguageService";

const rulesForm = reactive({
  "name.vi": [Validate.required],
  "name.en": [Validate.required],
  support_type: [Validate.requiredChange],
});

// thêm mới
const addNew = (formEl) => {
  validateFlag.value = true;
  if (!formEl) return;
  formEl.validate(async (valid) => {
    if (!valid) return;
    loadingBtn.value = true;
    const objectData = {
      name: {
        vi: dataForm.value.name.vi.trim(),
        en: dataForm.value.name.en.trim(),
      },
      support_type: dataForm.value.support_type,
    };
    if (
      dataForm.value.index !== undefined &&
      dataForm.value.index !== null &&
      dataForm.value.index !== ""
    ) {
      objectData.index = Number(dataForm.value.index);
    }
    if (dataForm.value.icon && dataForm.value.icon.trim()) {
      objectData.icon = dataForm.value.icon.trim();
    }
    objectData.tooltip =
      dataForm.value.tooltip && dataForm.value.tooltip.trim()
        ? dataForm.value.tooltip.trim()
        : null;
    try {
      const newId = await mushroom.search_strategy.createAsync(objectData);
      if (newId) {
        toastr.success(t("toastr_add_success"));
      }
      routerPush.go(-1);
    } catch (error) {
      if (error?.meta?.field === "$unique_key") {
        toastr.error(t("toastr_name_existed"));
      } else {
        console.error("Có lỗi: %o", error);
        MethodService.showError(error.code);
      }
    } finally {
      loadingBtn.value = false;
    }
  });
};

// cập nhật
const update = (formEl) => {
  validateFlag.value = true;
  if (!formEl) return;
  formEl.validate(async (valid) => {
    if (!valid) return;
    loadingBtn.value = true;
    const objectData = {
      id: router.params.id,
      name: {
        vi: dataForm.value.name.vi.trim(),
        en: dataForm.value.name.en.trim(),
      },
      support_type: dataForm.value.support_type,
    };
    if (
      dataForm.value.index !== undefined &&
      dataForm.value.index !== null &&
      dataForm.value.index !== ""
    ) {
      objectData.index = Number(dataForm.value.index);
    }
    if (dataForm.value.icon && dataForm.value.icon.trim()) {
      objectData.icon = dataForm.value.icon.trim();
    }
    objectData.tooltip =
      dataForm.value.tooltip && dataForm.value.tooltip.trim()
        ? dataForm.value.tooltip.trim()
        : null;
    try {
      const response = await mushroom.search_strategy.partialUpdateAsync(
        objectData,
      );
      if (response.result === router.params.id) {
        toastr.success(t("toastr_update_success"));
        routerPush.go(-1);
      }
    } catch (error) {
      if (error?.meta?.field === "$unique_key") {
        toastr.error(t("toastr_name_existed"));
      } else {
        console.error("Có lỗi: %o", error);
        MethodService.showError(error.code);
      }
    } finally {
      loadingBtn.value = false;
    }
  });
};

// lấy thông tin chi tiết
async function getDetailById() {
  mushroom.search_strategy.invalidCache();
  try {
    const response = await mushroom.search_strategy.findByIdAsync({
      id: router.params.id,
    });
    dataForm.value = response.result;
  } catch (e) {
    console.error("Có lỗi: %o", e);
    MethodService.showError(e.code);
  }
}

watch(
  () => lang_web.showLang,
  () => {
    lang.value = lang_web.showLang.toLocaleUpperCase();
    LanguageService.lang = LanguageService[lang.value];
    if (validateFlag.value)
      rulesForm.value = MethodService.copyObject(rulesForm);
  },
);

onMounted(() => {
  if (router.name === "ThemMoiSearchStrategy") {
    // form thêm mới
  } else {
    getDetailById();
  }
});
</script>

<template>
  <Layout>
    <div class="card">
      <div class="card-header">
        <h3 v-if="router.name === 'ThemMoiSearchStrategy'">
          {{ $t("t-add-search-strategy") }}
        </h3>
        <h3 v-else>{{ $t("t-update-search-strategy") }}</h3>
      </div>
      <div class="card-body">
        <div class="main-body">
          <el-form
            ref="ruleFormRef"
            :model="dataForm.value"
            status-icon
            :rules="rulesForm"
            label-width="200px"
            class="form-user"
          >
            <el-form-item
              :label="$t('t-search-strategy-name-vi')"
              prop="name.vi"
            >
              <el-input
                type="text"
                autocomplete="off"
                v-model="dataForm.value.name.vi"
                @change="dataForm.value.name.vi = dataForm.value.name.vi.trim()"
                :placeholder="$t('t-place-search-strategy-name-vi')"
              />
            </el-form-item>

            <el-form-item
              :label="$t('t-search-strategy-name-en')"
              prop="name.en"
            >
              <el-input
                type="text"
                autocomplete="off"
                v-model="dataForm.value.name.en"
                @change="dataForm.value.name.en = dataForm.value.name.en.trim()"
                :placeholder="$t('t-place-search-strategy-name-en')"
              />
            </el-form-item>

            <el-form-item :label="$t('t-search-strategy-icon')" prop="icon">
              <IconPicker v-model="dataForm.value.icon" :allow-text-input="true" />
            </el-form-item>

            <el-form-item
              :label="$t('t-search-strategy-tooltip')"
              prop="tooltip"
            >
              <el-input
                type="textarea"
                autocomplete="off"
                v-model="dataForm.value.tooltip"
                :placeholder="$t('t-place-search-strategy-tooltip')"
              />
            </el-form-item>

            <b-row>
              <b-col md="6">
                <el-form-item
                  :label="$t('t-search-strategy-support-type')"
                  prop="support_type"
                >
                  <el-select
                    v-model="dataForm.value.support_type"
                    :placeholder="$t('t-place-search-strategy-support-type')"
                    style="width: 100%"
                    :no-match-text="$t('t-match-data')"
                    :no-data-text="$t('t-no-data')"
                  >
                    <el-option
                      v-for="item in Data.supportTypeOptions"
                      :key="item.value"
                      :label="$t(item.labelKey)"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </b-col>
              <b-col md="6">
                <el-form-item
                  :label="$t('t-search-strategy-index')"
                  prop="index"
                >
                  <el-input-number
                    v-model="dataForm.value.index"
                    :min="1"
                    :step="1"
                    :precision="0"
                    :placeholder="$t('t-place-search-strategy-index')"
                    controls-position="right"
                    style="width: 100%"
                  />
                </el-form-item>
              </b-col>
            </b-row>

            <div class="text-center">
              <button
                type="button"
                class="btn btn-soft-secondary btn-border mx-3"
                @click="routerPush.go(-1)"
              >
                {{ $t("t-back") }}
              </button>
              <el-button
                type="button"
                style="height: 38px"
                class="btn btn-secondary btn-border"
                @click="addNew(ruleFormRef)"
                v-if="router.name === 'ThemMoiSearchStrategy'"
                :loading="loadingBtn"
              >
                {{ $t("t-add") }}
              </el-button>

              <el-button
                type="button"
                style="height: 38px"
                class="btn btn-secondary btn-border"
                @click="update(ruleFormRef)"
                :loading="loadingBtn"
                v-else
              >
                {{ $t("t-update") }}
              </el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
</style>
